<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ConfirmSend
			v-if="modalType === modalTypes.CREATE"
			@close="cancel"
			@submit="sendNotification"
			:name="sentData?.active_plan?.order"
		/>
	</DaModalFrame>
	<div class="__report-lesson px-10 md-down:px-4 pb-30">
		<div
			class="
				__report-lesson__header
				py-10
				flex flex-nowrap
				justify-between
				items-center
				gap-10
				md-down:flex-col md-down:items-start md-down:gap-6
			"
		>
			<div
				class="
					__record__title
					text-neutral-500
					font-semibold
					whitespace-nowrap
					flex flex-nowrap
					items-center
					text-4xl
				"
			>
				<DaIcon name="das--report" class="mr-3 h-6 w-6" />
				{{ $filters.terminology('plan') }} nhóm
			</div>
			<div class="w-full flex items-center justify-end">
				<div class="search-input max-w-lg w-full">
					<div class="input-group input--lg">
						<input
							type="text"
							placeholder="Gõ tên lớp nhóm để tìm kiếm"
							class="bg-white input-with-icon"
							v-model="searchQuery"
							@keyup="searching"
							@keypress.enter="search"
						/>
						<div class="input-icon absolute top-1/2">
							<DaIcon
								name="das--search"
								class="h-4 w-4 text-neutral-400"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!isLoading">
			<div v-if="plans.length > 0">
				<div
					class="
						grid
						gap-8
						md-down:gap-4
						mb-10
						sm-down:grid-cols-1
						grid-cols-3
					"
				>
					<div
						class="
							bg-white
							p-4
							rounded-xl
							border-sm
							shadow-sm
							flex
							items-center
							justify-between
						"
					>
						<div class="flex items-center flex-nowrap">
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clip-path="url(#clip0_20827_40027)">
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M3.7506 3.29111V2.48667C3.7506 2.36994 3.72761 2.25435 3.68294 2.1465C3.63827 2.03865 3.57279 1.94066 3.49025 1.85812C3.40771 1.77558 3.30972 1.7101 3.20187 1.66543C3.09402 1.62076 2.97843 1.59777 2.8617 1.59778H1.77723C1.77723 1.17402 1.94558 0.76762 2.24522 0.467979C2.54486 0.168339 2.95127 1.76804e-06 3.37502 0H17.9572C18.1671 0 18.3748 0.0413284 18.5687 0.121625C18.7625 0.201921 18.9387 0.319612 19.087 0.46798C19.2354 0.616348 19.3531 0.792485 19.4334 0.986337C19.5137 1.18019 19.555 1.38796 19.555 1.59778V18.4022C19.555 18.612 19.5137 18.8198 19.4334 19.0137C19.3531 19.2075 19.2354 19.3837 19.087 19.532C18.9387 19.6804 18.7625 19.7981 18.5687 19.8784C18.3748 19.9587 18.1671 20 17.9572 20H3.37503C2.95127 20 2.54487 19.8317 2.24522 19.532C1.94558 19.2324 1.77723 18.826 1.77723 18.4022H2.8617C2.97843 18.4022 3.09402 18.3792 3.20187 18.3346C3.30971 18.2899 3.4077 18.2244 3.49025 18.1419C3.57279 18.0593 3.63826 17.9613 3.68293 17.8535C3.7276 17.7457 3.75059 17.6301 3.75059 17.5133V16.7089C3.75059 16.5922 3.7276 16.4766 3.68293 16.3687C3.63826 16.2609 3.57279 16.1629 3.49025 16.0803C3.4077 15.9978 3.30971 15.9323 3.20187 15.8877C3.09402 15.843 2.97843 15.82 2.8617 15.82H1.77723V14.8467H2.8617C2.97843 14.8467 3.09402 14.8237 3.20187 14.779C3.30971 14.7343 3.4077 14.6689 3.49025 14.5863C3.57279 14.5038 3.63826 14.4058 3.68293 14.2979C3.7276 14.1901 3.75059 14.0745 3.75059 13.9578V13.1533C3.75059 13.0366 3.7276 12.921 3.68293 12.8132C3.63826 12.7053 3.57279 12.6073 3.49025 12.5248C3.4077 12.4422 3.30971 12.3768 3.20187 12.3321C3.09402 12.2874 2.97843 12.2644 2.8617 12.2644H1.77723V11.2911H2.8617C2.97843 11.2911 3.09402 11.2681 3.20187 11.2235C3.30971 11.1788 3.4077 11.1133 3.49025 11.0308C3.57279 10.9482 3.63826 10.8502 3.68293 10.7424C3.7276 10.6345 3.75059 10.519 3.75059 10.4022V9.59778C3.75059 9.48105 3.7276 9.36546 3.68293 9.25761C3.63826 9.14977 3.57279 9.05178 3.49025 8.96923C3.4077 8.88669 3.30971 8.82122 3.20187 8.77655C3.09402 8.73188 2.97843 8.70889 2.8617 8.70889H1.77723V7.73556H2.8617C2.97843 7.73556 3.09402 7.71257 3.20187 7.6679C3.30971 7.62323 3.4077 7.55775 3.49025 7.47521C3.57279 7.39267 3.63826 7.29468 3.68293 7.18683C3.7276 7.07899 3.75059 6.9634 3.75059 6.84667V6.04222C3.75059 5.92549 3.7276 5.8099 3.68293 5.70206C3.63826 5.59421 3.57279 5.49622 3.49025 5.41368C3.4077 5.33114 3.30971 5.26566 3.20187 5.22099C3.09402 5.17632 2.97843 5.15333 2.8617 5.15333H1.77723V4.18H2.86171C2.97844 4.18 3.09403 4.15701 3.20187 4.11234C3.30972 4.06767 3.40771 4.0022 3.49025 3.91966C3.57279 3.83711 3.63827 3.73912 3.68294 3.63128C3.72761 3.52343 3.7506 3.40784 3.7506 3.29111ZM13.7497 4.89583C13.347 4.89583 13.0205 5.22229 13.0205 5.625V14.375H12.2914V9.27083C12.2914 8.86813 11.9649 8.54167 11.5622 8.54167H10.1039C9.70115 8.54167 9.37469 8.86813 9.37469 9.27083V14.375H8.64553V12.1875C8.64553 11.7848 8.31907 11.4583 7.91636 11.4583H6.45803C6.05532 11.4583 5.72886 11.7848 5.72886 12.1875V14.375H5.36428C5.16292 14.375 4.99969 14.5382 4.99969 14.7396C4.99969 14.9409 5.16292 15.1042 5.36428 15.1042H16.3018C16.5031 15.1042 16.6664 14.9409 16.6664 14.7396C16.6664 14.5382 16.5031 14.375 16.3018 14.375H15.9372V5.625C15.9372 5.22229 15.6107 4.89583 15.208 4.89583H13.7497Z"
										fill="#2AA797"
									/>
									<path
										d="M2.86271 2.26481H0.666558C0.543828 2.26481 0.444336 2.3643 0.444336 2.48703V3.29081C0.444336 3.41354 0.543828 3.51303 0.666558 3.51303H2.86271C2.98544 3.51303 3.08493 3.41354 3.08493 3.29081V2.48703C3.08493 2.3643 2.98544 2.26481 2.86271 2.26481Z"
										fill="#2AA797"
									/>
									<path
										d="M0.666558 9.37592H2.86271C2.98544 9.37592 3.08493 9.47542 3.08493 9.59815V10.4019C3.08493 10.5247 2.98544 10.6241 2.86271 10.6241H0.666558C0.543828 10.6241 0.444336 10.5247 0.444336 10.4019V9.59815C0.444336 9.47542 0.543828 9.37592 0.666558 9.37592Z"
										fill="#2AA797"
									/>
									<path
										d="M2.86271 5.82037H0.666558C0.543828 5.82037 0.444336 5.91986 0.444336 6.04259V6.84637C0.444336 6.9691 0.543828 7.06859 0.666558 7.06859H2.86271C2.98544 7.06859 3.08493 6.9691 3.08493 6.84637V6.04259C3.08493 5.91986 2.98544 5.82037 2.86271 5.82037Z"
										fill="#2AA797"
									/>
									<path
										d="M2.86271 12.9315H0.666558C0.543828 12.9315 0.444336 13.031 0.444336 13.1537V13.9575C0.444336 14.0802 0.543828 14.1797 0.666558 14.1797H2.86271C2.98544 14.1797 3.08493 14.0802 3.08493 13.9575V13.1537C3.08493 13.031 2.98544 12.9315 2.86271 12.9315Z"
										fill="#2AA797"
									/>
									<path
										d="M2.86271 16.487H0.666558C0.543828 16.487 0.444336 16.5865 0.444336 16.7093V17.513C0.444336 17.6358 0.543828 17.7353 0.666558 17.7353H2.86271C2.98544 17.7353 3.08493 17.6358 3.08493 17.513V16.7093C3.08493 16.5865 2.98544 16.487 2.86271 16.487Z"
										fill="#2AA797"
									/>
								</g>
								<defs>
									<clipPath id="clip0_20827_40027">
										<rect
											width="20"
											height="20"
											fill="white"
										/>
									</clipPath>
								</defs>
							</svg>
							<div class="text-neutral-500 text-sm ml-2">
								KH hiện tại
							</div>
						</div>
						<div
							class="
								flex
								items-center
								flex-nowrap
								justify-between
							"
						>
							<div class="text-neutral-600 font-bold text-4xl">
								{{ stats?.active_plan_count || 0 }}/{{
									stats?.active_student_count || 0
								}}
							</div>
						</div>
					</div>
					<div
						class="
							bg-white
							p-4
							rounded-xl
							border-sm
							shadow-sm
							flex
							items-center
							justify-between
						"
					>
						<div class="flex items-center flex-nowrap">
							<svg
								width="21"
								height="20"
								viewBox="0 0 21 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M13.1978 10.0001C13.1978 11.5821 11.9152 12.8647 10.3332 12.8647C8.7511 12.8647 7.46859 11.5821 7.46859 10.0001C7.46859 8.41802 8.7511 7.1355 10.3332 7.1355C11.9152 7.1355 13.1978 8.41802 13.1978 10.0001Z"
									fill="#2AA797"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M1.1665 10.0001C1.1665 10.0001 4.604 3.698 10.3332 3.698C16.0623 3.698 19.4998 10.0001 19.4998 10.0001C19.4998 10.0001 16.0623 16.3022 10.3332 16.3022C4.604 16.3022 1.1665 10.0001 1.1665 10.0001ZM10.3332 14.0105C12.5481 14.0105 14.3436 12.215 14.3436 10.0001C14.3436 7.78519 12.5481 5.98966 10.3332 5.98966C8.11828 5.98966 6.32275 7.78519 6.32275 10.0001C6.32275 12.215 8.11828 14.0105 10.3332 14.0105Z"
									fill="#2AA797"
								/>
							</svg>
							<div class="text-neutral-500 text-sm ml-2">
								PH đã xem
							</div>
						</div>
						<div
							class="
								flex
								items-center
								flex-nowrap
								justify-between
							"
						>
							<div class="text-neutral-600 font-bold text-4xl">
								{{ stats?.total_parent_received || 0 }}
							</div>
						</div>
					</div>
					<div
						class="
							bg-white
							p-4
							rounded-xl
							border-sm
							shadow-sm
							flex
							items-center
							justify-between
						"
					>
						<div class="flex items-center flex-nowrap">
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M13.75 2.5C13.75 1.80964 14.3096 1.25 15 1.25H17.5C18.1904 1.25 18.75 1.80965 18.75 2.5V17.5H19.375C19.7202 17.5 20 17.7798 20 18.125C20 18.4702 19.7202 18.75 19.375 18.75H0.625C0.279822 18.75 0 18.4702 0 18.125C0 17.7798 0.279822 17.5 0.625 17.5H1.25V13.75C1.25 13.0596 1.80964 12.5 2.5 12.5H5C5.69036 12.5 6.25 13.0596 6.25 13.75V17.5H7.5V8.75C7.5 8.05964 8.05964 7.5 8.75 7.5H11.25C11.9404 7.5 12.5 8.05964 12.5 8.75V17.5H13.75V2.5Z"
									fill="#2AA797"
								/>
							</svg>
							<div class="text-neutral-500 text-sm ml-2">
								Kế hoạch dự kiến
							</div>
						</div>
						<div
							class="
								flex
								items-center
								flex-nowrap
								justify-between
							"
						>
							<div class="text-neutral-600 font-bold text-4xl">
								{{ stats?.scheduled_plan_count || 0 }}
							</div>
						</div>
					</div>
				</div>
				<div class="shadow-sm sm:rounded-2xl overflow-hidden">
					<div class="__record__table overflow-x-auto scroll-bar">
						<div
							class="
								overflow-hidden
								sm:rounded-t-2xl
								w-fit
								min-w-full
							"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											scope="col"
											class="
												px-3
												py-3
												text-center text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												w-16
											"
										>
											STT
										</th>
										<th
											scope="col"
											class="
												px-3
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												whitespace-nowrap
												tracking-wider
											"
											style="width: 200px"
										>
											tên lớp nhóm
										</th>
										<th
											scope="col"
											class="
												pr-3
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												tracking-wider
												uppercase
												whitespace-nowrap
											"
											style="width: 150px"
										>
											Kế hoạch dự kiến
										</th>
										<th
											scope="col"
											class="
												pr-3
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											style="width: 150px"
										>
											Kế hoạch hiện tại
										</th>
										<th
											scope="col"
											class="
												pr-3
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											style="width: 100px"
										>
											Gửi Kế hoạch
										</th>
										<th
											scope="col"
											class="
												pr-3
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											style="width: 100px"
										>
											PH ĐÃ XEM
										</th>
										<th
											scope="col"
											class="
												pr-3
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												tracking-wider
												uppercase
												whitespace-nowrap
											"
											style="width: 150px"
										>
											học sinh trong nhóm
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										@click="
											$router.push(
												`/group-class-plans/${plan?.id}`
											)
										"
										class="
											text-neutral-700
											hover:bg-orange-50
											cursor-pointer
										"
										v-for="(plan, i) in plans"
										:key="plan?.id"
										:class="
											i % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
									>
										<td>
											<div
												class="
													px-3
													py-4
													text-center text-neutral-700
												"
											>
												{{ i + 1 }}
											</div>
										</td>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div
												class="
													flex
													items-center
													cursor-pointer
												"
											>
												{{ plan?.name }}
											</div>
										</td>
										<td
											class="
												pr-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div
												v-if="plan?.pending_group_plan"
											>
												Kế hoạch
												{{
													plan?.pending_group_plan
														?.order
												}}
												<span>
													({{
														plan?.pending_group_plan
															?.goals_count || 0
													}}
													MT)</span
												>
											</div>
											<div v-else>-</div>
										</td>
										<td
											class="
												pr-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div v-if="plan?.active_group_plan">
												Kế hoạch
												{{
													plan?.active_group_plan
														?.order
												}}
												<span>
													({{
														plan?.active_group_plan
															?.goals_count || 0
													}}
													MT)</span
												>
											</div>
											<div v-else>-</div>
										</td>
										<td
											class="
												pr-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<button
												v-if="
													plan.students_count &&
													plan.parents_count &&
													plan?.active_group_plan &&
													!plan?.active_group_plan
														?.sent_at
												"
												@click.stop="
													openSendConfirm(plan)
												"
												type="button"
												class="
													button-p
													text-center
													whitespace-nowrap
													px-8
													btn--ghost
												"
											>
												Gửi
											</button>
											<span v-else>{{
												plan?.active_group_plan?.sent_at
													? 'Đã gửi'
													: '- '
											}}</span>
										</td>
										<td
											class="
												pr-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div>
												<span
													>{{
														plan?.parents_read_count
															?.order || '0'
													}}/</span
												>
												<span>{{
													plan?.parents_count || '0'
												}}</span>
											</div>
										</td>
										<td>
											<UserGroup
												v-if="plan.students?.length"
												:data="plan.students"
											/>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div
				v-else
				class="
					w-full
					h-full
					mt-20
					flex
					items-center
					justify-center
					flex-col
				"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div
					class="text-neutral-500 text-lg text-center"
					style="max-width: 700px"
				>
					Trung tâm chưa có {{ $filters.terminology('plan') }} nhóm 
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>
<script>
import { computed, defineComponent, ref } from 'vue';
import { $api } from '@/services';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import Loading from '@/components/common/Loading';
import UserGroup from '@/components/elements/UserGroup.vue';
import { _MODAL_TYPE } from '@/enums';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import { useStore } from 'vuex';
import ConfirmSend from '@/views/groupClassPlanDetail/confirmSend/ConfirmSend.vue';

export default defineComponent({
	name: 'GroupClassPlans',

	components: { ConfirmSend, DaModalFrame, UserGroup, Loading, DaIcon },

	setup() {
		const store = useStore();
		const plans = ref([]);
		const stats = ref({
			active_plan_count: 0,
			active_student_count: 0,
			library_count: 0,
			scheduled_plan_count: 0,
			total_parent_received: 0,
		});

		let typing = ref(null);
		let payload = ref(null);
		let searchQuery = ref('');
		let isLoading = ref(true);
		function searching() {
			clearInterval(typing.value);
			typing.value = setTimeout(() => {
				search();
			}, 1000);
		}

		async function search() {
			payload.value = {
				...payload.value,
				search: searchQuery.value,
			};
			await fetchPlans();
		}

		async function fetchPlans() {
			isLoading.value = true;
			try {
				const {
					data: { data },
				} = await $api.groupClasses.plans(payload.value);
				plans.value = data;
			} catch (e) {
				console.log(e);
			} finally {
				isLoading.value = false;
			}
		}

		let modalIsOpen = ref(false);
		let modalType = ref('');

		function cancel() {
			modalIsOpen.value = false;
			modalType.value = '';
			sentData.value = null;
		}

		const sentData = ref(null);

		const modalTypes = computed(() => _MODAL_TYPE);

		function openSendConfirm(item) {
			modalIsOpen.value = true;
			sentData.value = item;
			modalType.value = _MODAL_TYPE.CREATE;
		}

		async function sendNotification() {
			try {
				await $api.groupClasses.sendReport(
					sentData.value?.id,
					sentData.value.active_group_plan?.id
				);
				cancel();
				await fetchPlans();
				await store.dispatch('setAlertMessage', {
					message: 'Gửi kế hoạch đến phụ huynh thành công',
				});
			} catch (err) {
				await store.dispatch('setAlertMessage', {
					message:
						err?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		}

		fetchPlans();

		return {
			isLoading,
			plans,
			stats,
			searchQuery,
			modalType,
			modalTypes,
			modalIsOpen,
			sentData,
			searching,
			search,
			openSendConfirm,
			cancel,
			sendNotification,
		};
	},
});
</script>
